import { render, staticRenderFns } from "./EmailPDPA.vue?vue&type=template&id=7f11f37e&"
import script from "./EmailPDPA.vue?vue&type=script&lang=js&"
export * from "./EmailPDPA.vue?vue&type=script&lang=js&"
import style0 from "./EmailPDPA.vue?vue&type=style&index=0&id=7f11f37e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports